<template>
    <div id="app">
      <hl-MainApp :config="config" class="main-app">
        <hl-FunnelHeader />
        <div class="small-container bg-white">
          <hl-Progress class="hl-progress" :align-left="false" :paddingLR="false" lastItemDashed v-if="!isSignupLocked" />
          <router-view
            v-if="validationsLoaded"
            :signup="signup"
            :targetAction="targetAction"
          />
        </div>
      </hl-MainApp>
    </div>
</template>

<script>
import FunnelHeader from '@modules/husleie-framework/src/components/molecules/app/funnel/FunnelHeader.vue';
import MainApp from '@modules/husleie-framework/src/components/molecules/app/MainApp.vue';
import Progress from '@modules/husleie-framework/src/components/navigation/Progress.vue';
import RedirectOperations from '@modules/husleie-framework/src/static-classes/RedirectOperations.class';
import i18nCommon from '@modules/i18n/mixins/Common';
import hlValidationRules from '@modules/husleie-framework/src/mixins/hlValidationRules';

export default {
  mixins: [hlValidationRules, i18nCommon],
  components: {
    'hl-MainApp': MainApp,
    'hl-Progress': Progress,
    'hl-FunnelHeader': FunnelHeader,
  },
  data() {
    return {
      config: {
        getValidationRules: null,
        getFeatures: null,
      },

      isSignupLocked: false,

      signup: {
        user: {
          fullName: '',
          email: '',
          phonePrefix: '+47',
          cellPhone: '',
          password: '',
          passwordRepeat: '',
          accepted: {
            GDPR: false,
            terms: false,
          },
          verificationToken: '',
          verificationCode: '',
        },
        landlord: {
          type: 'private', // or company
          dateOfBirth: '', // ??
          company: {
            name: '',
            orgNumber: '',
          },

          searchCompany: {},

          address: {
            street: '',
            postalCode: '',
            postalArea: '',
          },
        },
        rentalObject: {
          category: 'apartment',
          address: {
            street: '',
            postalCode: '',
            postalArea: '',
            apartmentNumber: '',
            roomNumber: '',
            floor: '',
          },
        },
      },

      choose: {
        action: 'annonse',
      },

      targetAction: '',
      validationsLoaded: false,
    };
  },
  async mounted() {
    const prefix = process.env.VUE_APP_MARKET_IDENTIFIER;
    const { getValidationRules } = await import(`@/validations/${prefix}.validations`);
    const { getFeatures } = await import(`@/features/${prefix}.features`);
    this.config = { getValidationRules, getFeatures };

    await this.hlFetchValidationRules('signup_spa');
    this.validationsLoaded = true;

    await RedirectOperations.forceDashboardIfLoggedIn();

    // set highlighted target action for the /choose page
    this.targetAction = this.$route.query.target_action;
  },

  watch: {
    'signup.user.phonePrefix'(newValue) {
      // We set a window variable to make it available
      // for the validator valid-cell-phone.

      if (
        this.$route.name === 'home' &&
        this.$validator.fields.length > 0
      ) {
        window.user_phone_prefix = newValue;
        this.$validator.validate('user.cellPhone');
      }
    },
  },
}
</script>

<style lang="scss">
#app {
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  overflow-x: hidden;
}
</style>

<style lang="scss" scoped>
.hl-progress {
  margin-bottom: 1rem;
}
.main-app {
  padding-bottom: 100px;
}
</style>
